export default "__VITE_ASSET__35e0e3e3__"